import SlideBase from "react-slick";
import styled from "@emotion/styled";
import { getCdnImageSrc, VStack } from "goi_common";
import SlideItem from "./SlideItem";

const initialSlide = 0;

const ImageSlideSection = ({
  images,
  name,
}: {
  images: Array<any>;
  name: string;
}) => {
  return (
    <VStack position="relative">
      {images && images.length > 0 ? (
        <Slide
          initialSlide={initialSlide}
          autoplay
          autoplaySpeed={5000}
          pauseOnDotsHover={false}
          pauseOnHover={false}
          pauseOnFocus={false}
        >
          {images.map((image, index) => {
            return (
              <SlideItem
                key="index"
                src={getCdnImageSrc(image.url)}
                name={name}
              />
            );
          })}
        </Slide>
      ) : (
        <VStack
          height="0px"
          background="url(/images/no-image.png)"
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
        ></VStack>
      )}
    </VStack>
  );
};

const Slide = styled(SlideBase)`
  position: relative;

  .slick-arrow {
    position: absolute;
    top: 109px;
    width: 14px;
    height: 25px;
    font-size: 0;
    z-index: 10;
  }

  .slick-prev {
    left: 20px;
    background: url("/icons/leftArrow_white.svg") no-repeat;
    background-size: contain;
  }

  .slick-next {
    right: 20px;
    background: url("/icons/rightArrow_white.svg") no-repeat;
    background-size: contain;
  }
`;

export default ImageSlideSection;
